export default __webpack_public_path__ + "static/media/bear-6.ec292213.png";